"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ArrowRight } from "lucide-react";

export default function LiveBarTabsCta() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-[#0A0814] text-white overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(124,58,237,0.30) 0%, transparent 60%)" }}
      />
      <div
        className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(251,146,60,0.15) 0%, transparent 65%)" }}
      />

      <div className="relative max-w-[800px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-6" style={{ color: "#F472B6" }}>
            {t("A lot of bars still run a paper tab book.", "Muchos bares todavía usan tab en papel.")}
          </div>
          <h2 className="text-4xl md:text-[72px] font-black tracking-[-0.03em] leading-[1.02] mb-8">
            {t("Run real bar tabs.", "Corre tabs reales.")}
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #C4B5FD 0%, #F472B6 50%, #FB923C 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("Across every station.", "En cada estación.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[520px] mx-auto leading-relaxed mb-10">
            {t(
              "Open by name or VIP table. Recipe pours that decrement inventory. PIN-gated comps. Close with card, cash or split. Realtime sync across every station.",
              "Abre por nombre o mesa VIP. Pours por receta que restan inventario. Comps con PIN. Cierre con tarjeta, efectivo o split. Sync en vivo en cada estación."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/signup?vertical=nightlife"
              className="group inline-flex items-center gap-2 text-[15px] font-bold px-8 py-4 rounded-full hover:scale-[1.03] transition-transform shadow-2xl text-white"
              style={{
                background: "linear-gradient(135deg, #7C3AED 0%, #F472B6 100%)",
                boxShadow: "0 20px 60px rgba(124, 58, 237, 0.5)",
              }}
            >
              {t("Run real bar tabs →", "Corre tabs reales →")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/solution/nightlife"
              className="inline-flex items-center text-[14px] font-bold text-white/70 hover:text-white transition-colors px-4 py-2"
            >
              {t("See the full nightlife pitch →", "Ver el pitch completo →")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
